<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        NDC
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-dropdown label="類目表">
        <router-link class="navbar-item" to="ndc9#0">
          <div class="justify">
            <span>０</span>
            <span>総</span>
            <span>記</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#1">
          <div class="justify">
            <span>１</span>
            <span>哲</span>
            <span>学</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#2">
          <div class="justify">
            <span>２</span>
            <span>歴</span>
            <span>史</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#3">
          <div class="justify">
            <span>３</span>
            <span>社</span>
            <span>会</span>
            <span>科</span>
            <span>学</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#4">
          <div class="justify">
            <span>４</span>
            <span>自</span>
            <span>然</span>
            <span>科</span>
            <span>学</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#5">
          <div class="justify">
            <span>５</span>
            <span>技</span>
            <span>術</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#6">
          <div class="justify">
            <span>６</span>
            <span>産</span>
            <span>業</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#7">
          <div class="justify">
            <span>７</span>
            <span>芸</span>
            <span>術</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#8">
          <div class="justify">
            <span>８</span>
            <span>言</span>
            <span>語</span>
          </div>
        </router-link>

        <router-link class="navbar-item" to="ndc9#9">
          <div class="justify">
            <span>９</span>
            <span>文</span>
            <span>学</span>
          </div>
        </router-link>
      </b-navbar-dropdown>
    </template>
    <template slot="end">
    </template>
  </b-navbar>
</template>


<script>
export default {
  name: 'Navbar',
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.justify {
  width: 5rem;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue